import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

/**
 * Small floating card that appears when Chrome fires beforeinstallprompt.
 * Lets the user install the app to home screen (Android/desktop).
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem("pwa_install_dismissed") === "1"; }
    catch { return false; }
  });

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => setDeferred(null);
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferred || dismissed) return null;

  const install = async () => {
    try {
      deferred.prompt();
      await deferred.userChoice;
    } finally {
      setDeferred(null);
    }
  };
  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem("pwa_install_dismissed", "1"); } catch { /* ignore */ }
  };

  return (
    <div
      className="fixed bottom-4 right-4 z-40 flex items-center gap-3 bg-slate-900 text-white shadow-xl rounded-lg px-4 py-3 max-w-sm"
      data-testid="pwa-install-prompt"
    >
      <Download className="w-5 h-5 text-blue-300 shrink-0" />
      <div className="text-sm flex-1 min-w-0">
        <div className="font-semibold">Instala Gestor de Taller</div>
        <div className="text-xs text-slate-300">Acceso rápido desde tu pantalla de inicio.</div>
      </div>
      <Button size="sm" onClick={install} className="bg-blue-600 hover:bg-blue-700" data-testid="pwa-install-btn">
        Instalar
      </Button>
      <button onClick={dismiss} className="text-slate-400 hover:text-white p-1" data-testid="pwa-dismiss-btn" aria-label="Descartar">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
